import { getCompanyInfo } from "./getCompanyInfo";

/** 开启点击行为日志上报 */
export const isEnableClickLog = () => ['localhost', 'app.cartsee.com'].includes(window.location.hostname);

/** 开启新服务 */
export const isEnableNewService = () => true;

export const isEnableWheelCouponSetting = () => {
  return true;
}

export const isEnablePopupCover = () => {
  return true;
};

export const isEnablePrivacySetting = () => {
  return true;
}

export const isEnableCombinedDiscountCode = () => {
  return true;
}

export const isEnablePopSetting = () => {
  return [
    30, 621, 3243, 689, 724, 838, 884, 895, 1034, 1040, 1378, 1451, 1459, 1510, 1535, 1598, 1657, 1661, 1682, 1737, 1739, 2095, 2096, 2123, 2152, 2244, 2273, 2377, 2452, 2641, 2691, 2783, 3089, 3456
  ].includes(getCompanyInfo().id as number);;
};

export const isEnableAuth = () => {
  return [30, 328, 565, 621, 1227, 1533, 2224, 2346, 2347, 2348, 2349, 2350, 2351, 907, 2523, 2733, 1738, 3140, 3048, 1756, 1893, 3221, 1289, 1292, 1400, 1401, 1455, 1456, 1482, 1483, 1484, 1485, 2005].includes(getCompanyInfo().id as number);
};

export const isEnableCustomStep = () => {
  return [30, 621, 1756, 328, 2631, 3575].includes(getCompanyInfo().id as number);
};

/** 是否支持easy-mail */
export const isEnableEasyMailEditor = (): boolean => {
  return (getCompanyInfo().emailEditorStatus === 1 || getCompanyInfo().emailEditorStatus === 3);
};
